import ProductItem from "./container";

export default ProductItem;